export default __webpack_public_path__ + "static/media/k8s.e8cf8c96.png";